var _path, _g, _g2, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimesheetEmptyImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1120,
    height: 560,
    viewBox: "0 0 1120 560",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4608_134371)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4608_134371",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1120,
    height: 560
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1120 0H0V560H1120V0Z",
    fill: "url(#paint0_radial_4608_134371)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4608_134371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-31.1113 0H62.222V93.3333H-31.1113V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.222 91.7778H-31.1113V93.3334H62.222V91.7778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2216 0H60.666V93.3333H62.2216V0Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2217 0H155.555V93.3333H62.2217V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.555 91.7778H62.2217V93.3334H155.555V91.7778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.556 0H154V93.3333H155.556V0Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.556 0H248.889V93.3333H155.556V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.889 91.7778H155.556V93.3334H248.889V91.7778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.889 0H247.333V93.3333H248.889V0Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.889 0H342.222V93.3333H248.889V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.222 91.7778H248.889V93.3334H342.222V91.7778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.222 0H340.666V93.3333H342.222V0Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.222 0H435.555V93.3333H342.222V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.555 91.7778H342.222V93.3334H435.555V91.7778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.556 0H434V93.3333H435.556V0Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.556 0H528.889V93.3333H435.556V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.889 91.7778H435.556V93.3334H528.889V91.7778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.889 0H527.333V93.3333H528.889V0Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.889 0H622.222V93.3333H528.889V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.222 91.7778H528.889V93.3334H622.222V91.7778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.222 0H620.666V93.3333H622.222V0Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.222 0H715.555V93.3333H622.222V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.555 91.7778H622.222V93.3334H715.555V91.7778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.556 0H714V93.3333H715.556V0Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.556 0H808.889V93.3333H715.556V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.889 91.7778H715.556V93.3334H808.889V91.7778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.889 0H807.333V93.3333H808.889V0Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.889 0H902.222V93.3333H808.889V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.222 91.7778H808.889V93.3334H902.222V91.7778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.222 0H900.666V93.3333H902.222V0Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.222 0H995.555V93.3333H902.222V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.555 91.7778H902.222V93.3334H995.555V91.7778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.556 0H994V93.3333H995.556V0Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.556 0H1088.89V93.3333H995.556V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.89 91.7778H995.556V93.3334H1088.89V91.7778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.89 0H1087.33V93.3333H1088.89V0Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-31.1113 93.3335H62.222V186.667H-31.1113V93.3335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.222 185.111H-31.1113V186.667H62.222V185.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2216 93.3335H60.666V186.667H62.2216V93.3335Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2217 93.3335H155.555V186.667H62.2217V93.3335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.555 185.111H62.2217V186.667H155.555V185.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.556 93.3335H154V186.667H155.556V93.3335Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.556 93.3335H248.889V186.667H155.556V93.3335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.889 185.111H155.556V186.667H248.889V185.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.889 93.3335H247.333V186.667H248.889V93.3335Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.889 93.3335H342.222V186.667H248.889V93.3335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.222 185.111H248.889V186.667H342.222V185.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.222 93.3335H340.666V186.667H342.222V93.3335Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M342.222 93.3335H435.555V186.667H342.222V93.3335Z",
    fill: "#0F172B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.555 185.111H342.222V186.667H435.555V185.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.556 93.3335H434V186.667H435.556V93.3335Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.556 93.3335H528.889V186.667H435.556V93.3335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.889 185.111H435.556V186.667H528.889V185.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.889 93.3335H527.333V186.667H528.889V93.3335Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.889 93.3335H622.222V186.667H528.889V93.3335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.222 185.111H528.889V186.667H622.222V185.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.222 93.3335H620.666V186.667H622.222V93.3335Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M622.222 93.3335H715.555V186.667H622.222V93.3335Z",
    fill: "#0F172B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.555 185.111H622.222V186.667H715.555V185.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.556 93.3335H714V186.667H715.556V93.3335Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.556 93.3335H808.889V186.667H715.556V93.3335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.889 185.111H715.556V186.667H808.889V185.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.889 93.3335H807.333V186.667H808.889V93.3335Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.889 93.3335H902.222V186.667H808.889V93.3335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.222 185.111H808.889V186.667H902.222V185.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.222 93.3335H900.666V186.667H902.222V93.3335Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.222 93.3335H995.555V186.667H902.222V93.3335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.555 185.111H902.222V186.667H995.555V185.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.556 93.3335H994V186.667H995.556V93.3335Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.556 93.3335H1088.89V186.667H995.556V93.3335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.89 185.111H995.556V186.667H1088.89V185.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.89 93.3335H1087.33V186.667H1088.89V93.3335Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-31.1113 186.667H62.222V280H-31.1113V186.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.222 278.444H-31.1113V280H62.222V278.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2216 186.667H60.666V280H62.2216V186.667Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M62.2217 186.667H155.555V280H62.2217V186.667Z",
    fill: "#0F172B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.555 278.444H62.2217V280H155.555V278.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.556 186.667H154V280H155.556V186.667Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.556 186.667H248.889V280H155.556V186.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.889 278.444H155.556V280H248.889V278.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.889 186.667H247.333V280H248.889V186.667Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.889 186.667H342.222V280H248.889V186.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.222 278.444H248.889V280H342.222V278.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.222 186.667H340.666V280H342.222V186.667Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.222 186.667H435.555V280H342.222V186.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.555 278.444H342.222V280H435.555V278.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.556 186.667H434V280H435.556V186.667Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.556 186.667H528.889V280H435.556V186.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.889 278.444H435.556V280H528.889V278.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.889 186.667H527.333V280H528.889V186.667Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.889 186.667H622.222V280H528.889V186.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.222 278.444H528.889V280H622.222V278.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.222 186.667H620.666V280H622.222V186.667Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.222 186.667H715.555V280H622.222V186.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.555 278.444H622.222V280H715.555V278.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.556 186.667H714V280H715.556V186.667Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.556 186.667H808.889V280H715.556V186.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.889 278.444H715.556V280H808.889V278.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.889 186.667H807.333V280H808.889V186.667Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M808.889 186.667H902.222V280H808.889V186.667Z",
    fill: "#0F172B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.222 278.444H808.889V280H902.222V278.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.222 186.667H900.666V280H902.222V186.667Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.222 186.667H995.555V280H902.222V186.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.555 278.444H902.222V280H995.555V278.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.556 186.667H994V280H995.556V186.667Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.556 186.667H1088.89V280H995.556V186.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.89 278.444H995.556V280H1088.89V278.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.89 186.667H1087.33V280H1088.89V186.667Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-31.1113 280H62.222V373.333H-31.1113V280Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.222 371.778H-31.1113V373.333H62.222V371.778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2216 280H60.666V373.333H62.2216V280Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2217 280H155.555V373.333H62.2217V280Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.555 371.778H62.2217V373.333H155.555V371.778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.556 280H154V373.333H155.556V280Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.556 280H248.889V373.333H155.556V280Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.889 371.778H155.556V373.333H248.889V371.778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.889 280H247.333V373.333H248.889V280Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M248.889 280H342.222V373.333H248.889V280Z",
    fill: "#0F172B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.222 371.778H248.889V373.333H342.222V371.778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.222 280H340.666V373.333H342.222V280Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.222 280H435.555V373.333H342.222V280Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.555 371.778H342.222V373.333H435.555V371.778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.556 280H434V373.333H435.556V280Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.556 280H528.889V373.333H435.556V280Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.889 371.778H435.556V373.333H528.889V371.778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.889 280H527.333V373.333H528.889V280Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.889 280H622.222V373.333H528.889V280Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.222 371.778H528.889V373.333H622.222V371.778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.222 280H620.666V373.333H622.222V280Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M622.222 280H715.555V373.333H622.222V280Z",
    fill: "#0F172B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.555 371.778H622.222V373.333H715.555V371.778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.556 280H714V373.333H715.556V280Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.556 280H808.889V373.333H715.556V280Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.889 371.778H715.556V373.333H808.889V371.778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.889 280H807.333V373.333H808.889V280Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.889 280H902.222V373.333H808.889V280Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.222 371.778H808.889V373.333H902.222V371.778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.222 280H900.666V373.333H902.222V280Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.222 280H995.555V373.333H902.222V280Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.555 371.778H902.222V373.333H995.555V371.778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.556 280H994V373.333H995.556V280Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.556 280H1088.89V373.333H995.556V280Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.89 371.778H995.556V373.333H1088.89V371.778Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.89 280H1087.33V373.333H1088.89V280Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-31.1113 373.333H62.222V466.667H-31.1113V373.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.222 465.111H-31.1113V466.667H62.222V465.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2216 373.333H60.666V466.667H62.2216V373.333Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2217 373.333H155.555V466.667H62.2217V373.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.555 465.111H62.2217V466.667H155.555V465.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.556 373.333H154V466.667H155.556V373.333Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.556 373.333H248.889V466.667H155.556V373.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.889 465.111H155.556V466.667H248.889V465.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.889 373.333H247.333V466.667H248.889V373.333Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.889 373.333H342.222V466.667H248.889V373.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.222 465.111H248.889V466.667H342.222V465.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.222 373.333H340.666V466.667H342.222V373.333Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.222 373.333H435.555V466.667H342.222V373.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.555 465.111H342.222V466.667H435.555V465.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.556 373.333H434V466.667H435.556V373.333Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M435.556 373.333H528.889V466.667H435.556V373.333Z",
    fill: "#0F172B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.889 465.111H435.556V466.667H528.889V465.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.889 373.333H527.333V466.667H528.889V373.333Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.889 373.333H622.222V466.667H528.889V373.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.222 465.111H528.889V466.667H622.222V465.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.222 373.333H620.666V466.667H622.222V373.333Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.222 373.333H715.555V466.667H622.222V373.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.555 465.111H622.222V466.667H715.555V465.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.556 373.333H714V466.667H715.556V373.333Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.556 373.333H808.889V466.667H715.556V373.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.889 465.111H715.556V466.667H808.889V465.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.889 373.333H807.333V466.667H808.889V373.333Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.889 373.333H902.222V466.667H808.889V373.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.222 465.111H808.889V466.667H902.222V465.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.222 373.333H900.666V466.667H902.222V373.333Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.222 373.333H995.555V466.667H902.222V373.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.555 465.111H902.222V466.667H995.555V465.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.556 373.333H994V466.667H995.556V373.333Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.556 373.333H1088.89V466.667H995.556V373.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.89 465.111H995.556V466.667H1088.89V465.111Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.89 373.333H1087.33V466.667H1088.89V373.333Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-31.1113 466.667H62.222V560H-31.1113V466.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.222 558.444H-31.1113V560H62.222V558.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2216 466.667H60.666V560H62.2216V466.667Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2217 466.667H155.555V560H62.2217V466.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.555 558.444H62.2217V560H155.555V558.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.556 466.667H154V560H155.556V466.667Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.556 466.667H248.889V560H155.556V466.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.889 558.444H155.556V560H248.889V558.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.889 466.667H247.333V560H248.889V466.667Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.889 466.667H342.222V560H248.889V466.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.222 558.444H248.889V560H342.222V558.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.222 466.667H340.666V560H342.222V466.667Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.222 466.667H435.555V560H342.222V466.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.555 558.444H342.222V560H435.555V558.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.556 466.667H434V560H435.556V466.667Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.556 466.667H528.889V560H435.556V466.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.889 558.444H435.556V560H528.889V558.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.889 466.667H527.333V560H528.889V466.667Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.889 466.667H622.222V560H528.889V466.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.222 558.444H528.889V560H622.222V558.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.222 466.667H620.666V560H622.222V466.667Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.222 466.667H715.555V560H622.222V466.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.555 558.444H622.222V560H715.555V558.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.556 466.667H714V560H715.556V466.667Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.556 466.667H808.889V560H715.556V466.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.889 558.444H715.556V560H808.889V558.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.889 466.667H807.333V560H808.889V466.667Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.889 466.667H902.222V560H808.889V466.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.222 558.444H808.889V560H902.222V558.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.222 466.667H900.666V560H902.222V466.667Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.222 466.667H995.555V560H902.222V466.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.555 558.444H902.222V560H995.555V558.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.556 466.667H994V560H995.556V466.667Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.556 466.667H1088.89V560H995.556V466.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.89 558.444H995.556V560H1088.89V558.444Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.89 466.667H1087.33V560H1088.89V466.667Z",
    fill: "#F1F5F9"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622 194H502C496.477 194 492 198.477 492 204V324C492 329.523 496.477 334 502 334H622C627.523 334 632 329.523 632 324V204C632 198.477 627.523 194 622 194Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4608_134371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606 204H471C468.239 204 466 206.239 466 209V234C466 236.761 468.239 239 471 239H606C608.761 239 611 236.761 611 234V209C611 206.239 608.761 204 606 204Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M535 212H509C507.343 212 506 213.343 506 215C506 216.657 507.343 218 509 218H535C536.657 218 538 216.657 538 215C538 213.343 536.657 212 535 212Z",
    fill: "#CAD5E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553 225H509C507.343 225 506 226.343 506 228C506 229.657 507.343 231 509 231H553C554.657 231 556 229.657 556 228C556 226.343 554.657 225 553 225Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493 207H474C471.239 207 469 209.239 469 212V231C469 233.761 471.239 236 474 236H493C495.761 236 498 233.761 498 231V212C498 209.239 495.761 207 493 207Z",
    fill: "#62748E"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4608_134371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.5 220L483.5 221.5V218",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.5 227.5C482.313 227.5 481.153 227.148 480.167 226.489C479.18 225.83 478.411 224.892 477.957 223.796C477.503 222.7 477.384 221.493 477.615 220.329C477.847 219.166 478.418 218.096 479.257 217.257C480.096 216.418 481.166 215.847 482.329 215.615C483.493 215.384 484.7 215.503 485.796 215.957C486.892 216.411 487.83 217.18 488.489 218.167C489.148 219.153 489.5 220.313 489.5 221.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.5 226C488.328 226 489 225.328 489 224.5C489 223.672 488.328 223 487.5 223C486.672 223 486 223.672 486 224.5C486 225.328 486.672 226 487.5 226Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.5 227.5C485.729 226.637 486.538 226 487.5 226C488.462 226 489.271 226.637 489.5 227.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4608_134371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514 247H649C650.326 247 651.598 247.527 652.536 248.464C653.473 249.402 654 250.674 654 252V277C654 278.326 653.473 279.598 652.536 280.536C651.598 281.473 650.326 282 649 282H514C512.674 282 511.402 281.473 510.464 280.536C509.527 279.598 509 278.326 509 277V252C509 250.674 509.527 249.402 510.464 248.464C511.402 247.527 512.674 247 514 247V247Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M578 255H552C550.343 255 549 256.343 549 258C549 259.657 550.343 261 552 261H578C579.657 261 581 259.657 581 258C581 256.343 579.657 255 578 255Z",
    fill: "#CAD5E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596 268H552C550.343 268 549 269.343 549 271C549 272.657 550.343 274 552 274H596C597.657 274 599 272.657 599 271C599 269.343 597.657 268 596 268Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536 250H517C514.239 250 512 252.239 512 255V274C512 276.761 514.239 279 517 279H536C538.761 279 541 276.761 541 274V255C541 252.239 538.761 250 536 250Z",
    fill: "#62748E"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4608_134371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M529.5 263L526.5 264.5V261",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.5 270.5C525.313 270.5 524.153 270.148 523.167 269.489C522.18 268.83 521.411 267.892 520.957 266.796C520.503 265.7 520.384 264.493 520.615 263.329C520.847 262.166 521.418 261.096 522.257 260.257C523.096 259.418 524.166 258.847 525.329 258.615C526.493 258.384 527.7 258.503 528.796 258.957C529.892 259.411 530.83 260.18 531.489 261.167C532.148 262.153 532.5 263.313 532.5 264.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.5 269C531.328 269 532 268.328 532 267.5C532 266.672 531.328 266 530.5 266C529.672 266 529 266.672 529 267.5C529 268.328 529.672 269 530.5 269Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.5 270.5C528.729 269.637 529.538 269 530.5 269C531.462 269 532.271 269.637 532.5 270.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4608_134371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471 290H606C607.326 290 608.598 290.527 609.536 291.464C610.473 292.402 611 293.674 611 295V320C611 321.326 610.473 322.598 609.536 323.536C608.598 324.473 607.326 325 606 325H471C469.674 325 468.402 324.473 467.464 323.536C466.527 322.598 466 321.326 466 320V295C466 293.674 466.527 292.402 467.464 291.464C468.402 290.527 469.674 290 471 290V290Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M535 298H509C507.343 298 506 299.343 506 301C506 302.657 507.343 304 509 304H535C536.657 304 538 302.657 538 301C538 299.343 536.657 298 535 298Z",
    fill: "#CAD5E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553 311H509C507.343 311 506 312.343 506 314C506 315.657 507.343 317 509 317H553C554.657 317 556 315.657 556 314C556 312.343 554.657 311 553 311Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493 293H474C471.239 293 469 295.239 469 298V317C469 319.761 471.239 322 474 322H493C495.761 322 498 319.761 498 317V298C498 295.239 495.761 293 493 293Z",
    fill: "#62748E"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_4608_134371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.5 306L483.5 307.5V304",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.5 313.5C482.313 313.5 481.153 313.148 480.167 312.489C479.18 311.83 478.411 310.892 477.957 309.796C477.503 308.7 477.384 307.493 477.615 306.329C477.847 305.166 478.418 304.096 479.257 303.257C480.096 302.418 481.166 301.847 482.329 301.615C483.493 301.384 484.7 301.503 485.796 301.957C486.892 302.411 487.83 303.18 488.489 304.167C489.148 305.153 489.5 306.313 489.5 307.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.5 312C488.328 312 489 311.328 489 310.5C489 309.672 488.328 309 487.5 309C486.672 309 486 309.672 486 310.5C486 311.328 486.672 312 487.5 312Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.5 313.5C485.729 312.637 486.538 312 487.5 312C488.462 312 489.271 312.637 489.5 313.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M456.268 360H454.636L448.508 350.752V360H446.94V348.656H449.036L454.7 357.36V348.656H456.268V360ZM460.567 358.176C461.036 358.656 461.607 358.896 462.279 358.896C462.951 358.896 463.516 358.656 463.975 358.176C464.444 357.685 464.679 357.008 464.679 356.144C464.679 355.291 464.444 354.624 463.975 354.144C463.516 353.653 462.951 353.408 462.279 353.408C461.607 353.408 461.036 353.653 460.567 354.144C460.108 354.624 459.879 355.291 459.879 356.144C459.879 357.008 460.108 357.685 460.567 358.176ZM459.447 353.232C460.194 352.453 461.138 352.064 462.279 352.064C463.42 352.064 464.359 352.453 465.095 353.232C465.842 354 466.215 354.971 466.215 356.144C466.215 357.328 465.847 358.309 465.111 359.088C464.375 359.856 463.431 360.24 462.279 360.24C461.127 360.24 460.183 359.856 459.447 359.088C458.711 358.309 458.343 357.328 458.343 356.144C458.343 354.971 458.711 354 459.447 353.232ZM471.659 357.936C471.659 357.275 471.873 356.747 472.299 356.352C472.726 355.947 473.291 355.696 473.995 355.6L476.075 355.296C476.47 355.243 476.667 355.051 476.667 354.72C476.667 354.315 476.529 353.984 476.251 353.728C475.974 353.472 475.558 353.344 475.003 353.344C474.491 353.344 474.086 353.488 473.787 353.776C473.489 354.053 473.313 354.427 473.259 354.896L471.819 354.56C471.894 353.824 472.23 353.227 472.827 352.768C473.425 352.299 474.139 352.064 474.971 352.064C476.059 352.064 476.865 352.331 477.387 352.864C477.91 353.387 478.171 354.059 478.171 354.88V358.736C478.171 359.195 478.203 359.616 478.267 360H476.795C476.742 359.68 476.715 359.333 476.715 358.96C476.502 359.301 476.187 359.6 475.771 359.856C475.366 360.112 474.854 360.24 474.235 360.24C473.478 360.24 472.859 360.016 472.379 359.568C471.899 359.109 471.659 358.565 471.659 357.936ZM474.443 358.976C475.115 358.976 475.654 358.795 476.059 358.432C476.465 358.069 476.667 357.493 476.667 356.704V356.352L474.315 356.704C473.974 356.757 473.702 356.88 473.499 357.072C473.297 357.264 473.195 357.525 473.195 357.856C473.195 358.155 473.307 358.416 473.531 358.64C473.766 358.864 474.07 358.976 474.443 358.976ZM482.53 349.872V352.304H484.194V353.664H482.53V357.664C482.53 358.027 482.61 358.293 482.77 358.464C482.941 358.635 483.218 358.72 483.602 358.72C483.826 358.72 484.024 358.699 484.194 358.656V359.936C483.938 360.032 483.597 360.08 483.17 360.08C482.509 360.08 481.986 359.888 481.602 359.504C481.218 359.12 481.026 358.581 481.026 357.888V353.664H479.554V352.304H479.97C480.365 352.304 480.658 352.197 480.85 351.984C481.053 351.76 481.154 351.472 481.154 351.12V349.872H482.53ZM488.218 349.872V352.304H489.882V353.664H488.218V357.664C488.218 358.027 488.298 358.293 488.458 358.464C488.629 358.635 488.906 358.72 489.29 358.72C489.514 358.72 489.711 358.699 489.882 358.656V359.936C489.626 360.032 489.285 360.08 488.858 360.08C488.197 360.08 487.674 359.888 487.29 359.504C486.906 359.12 486.714 358.581 486.714 357.888V353.664H485.242V352.304H485.658C486.053 352.304 486.346 352.197 486.538 351.984C486.741 351.76 486.842 351.472 486.842 351.12V349.872H488.218ZM492.787 355.36H496.995C496.974 354.784 496.782 354.315 496.419 353.952C496.057 353.579 495.545 353.392 494.883 353.392C494.286 353.392 493.795 353.589 493.411 353.984C493.027 354.368 492.819 354.827 492.787 355.36ZM497.219 357.36L498.515 357.808C498.291 358.523 497.875 359.109 497.267 359.568C496.659 360.016 495.923 360.24 495.059 360.24C493.982 360.24 493.065 359.872 492.307 359.136C491.561 358.389 491.187 357.387 491.187 356.128C491.187 354.955 491.55 353.984 492.275 353.216C493.001 352.448 493.865 352.064 494.867 352.064C496.03 352.064 496.937 352.432 497.587 353.168C498.238 353.893 498.563 354.869 498.563 356.096C498.563 356.288 498.553 356.448 498.531 356.576H492.739C492.75 357.259 492.974 357.819 493.411 358.256C493.859 358.693 494.409 358.912 495.059 358.912C496.158 358.912 496.878 358.395 497.219 357.36ZM501.987 355.552V360H500.483V352.304H501.955V353.408C502.467 352.523 503.256 352.08 504.323 352.08C505.208 352.08 505.886 352.363 506.355 352.928C506.835 353.493 507.075 354.224 507.075 355.12V360H505.571V355.376C505.571 354.085 504.974 353.44 503.779 353.44C503.214 353.44 502.771 353.643 502.451 354.048C502.142 354.443 501.987 354.944 501.987 355.552ZM510.364 356.128C510.364 356.939 510.561 357.6 510.956 358.112C511.361 358.624 511.916 358.88 512.62 358.88C513.292 358.88 513.83 358.619 514.236 358.096C514.641 357.573 514.844 356.907 514.844 356.096C514.844 355.296 514.646 354.651 514.252 354.16C513.857 353.669 513.318 353.424 512.636 353.424C511.953 353.424 511.404 353.675 510.988 354.176C510.572 354.677 510.364 355.328 510.364 356.128ZM514.86 358.96V358.832C514.657 359.227 514.348 359.557 513.932 359.824C513.526 360.08 513.041 360.208 512.476 360.208C511.377 360.208 510.492 359.824 509.82 359.056C509.158 358.277 508.828 357.301 508.828 356.128C508.828 355.008 509.169 354.059 509.852 353.28C510.534 352.491 511.409 352.096 512.476 352.096C513.105 352.096 513.617 352.224 514.012 352.48C514.406 352.725 514.678 353.029 514.828 353.392V348.416H516.316V358.576C516.316 359.099 516.342 359.573 516.396 360H514.94C514.886 359.701 514.86 359.355 514.86 358.96ZM518.394 357.936C518.394 357.275 518.607 356.747 519.034 356.352C519.46 355.947 520.026 355.696 520.73 355.6L522.81 355.296C523.204 355.243 523.402 355.051 523.402 354.72C523.402 354.315 523.263 353.984 522.986 353.728C522.708 353.472 522.292 353.344 521.738 353.344C521.226 353.344 520.82 353.488 520.522 353.776C520.223 354.053 520.047 354.427 519.994 354.896L518.554 354.56C518.628 353.824 518.964 353.227 519.562 352.768C520.159 352.299 520.874 352.064 521.706 352.064C522.794 352.064 523.599 352.331 524.122 352.864C524.644 353.387 524.906 354.059 524.906 354.88V358.736C524.906 359.195 524.938 359.616 525.002 360H523.53C523.476 359.68 523.45 359.333 523.45 358.96C523.236 359.301 522.922 359.6 522.506 359.856C522.1 360.112 521.588 360.24 520.97 360.24C520.212 360.24 519.594 360.016 519.114 359.568C518.634 359.109 518.394 358.565 518.394 357.936ZM521.178 358.976C521.85 358.976 522.388 358.795 522.794 358.432C523.199 358.069 523.402 357.493 523.402 356.704V356.352L521.05 356.704C520.708 356.757 520.436 356.88 520.234 357.072C520.031 357.264 519.93 357.525 519.93 357.856C519.93 358.155 520.042 358.416 520.266 358.64C520.5 358.864 520.804 358.976 521.178 358.976ZM528.753 355.552V360H527.249V352.304H528.721V353.408C529.233 352.523 530.022 352.08 531.089 352.08C531.974 352.08 532.651 352.363 533.121 352.928C533.601 353.493 533.841 354.224 533.841 355.12V360H532.337V355.376C532.337 354.085 531.739 353.44 530.545 353.44C529.979 353.44 529.537 353.643 529.217 354.048C528.907 354.443 528.753 354.944 528.753 355.552ZM539.465 353.456C538.814 353.456 538.26 353.691 537.801 354.16C537.353 354.629 537.129 355.291 537.129 356.144C537.129 356.987 537.353 357.648 537.801 358.128C538.26 358.608 538.82 358.848 539.481 358.848C540.121 358.848 540.606 358.688 540.937 358.368C541.278 358.048 541.508 357.68 541.625 357.264L542.953 357.84C542.74 358.48 542.334 359.04 541.737 359.52C541.15 360 540.398 360.24 539.481 360.24C538.361 360.24 537.433 359.851 536.697 359.072C535.961 358.293 535.593 357.317 535.593 356.144C535.593 354.949 535.961 353.973 536.697 353.216C537.433 352.448 538.356 352.064 539.465 352.064C540.404 352.064 541.161 352.304 541.737 352.784C542.324 353.264 542.708 353.84 542.889 354.512L541.529 355.088C541.412 354.64 541.188 354.256 540.857 353.936C540.526 353.616 540.062 353.456 539.465 353.456ZM545.615 355.36H549.823C549.802 354.784 549.61 354.315 549.247 353.952C548.885 353.579 548.373 353.392 547.711 353.392C547.114 353.392 546.623 353.589 546.239 353.984C545.855 354.368 545.647 354.827 545.615 355.36ZM550.047 357.36L551.343 357.808C551.119 358.523 550.703 359.109 550.095 359.568C549.487 360.016 548.751 360.24 547.887 360.24C546.81 360.24 545.893 359.872 545.135 359.136C544.389 358.389 544.015 357.387 544.015 356.128C544.015 354.955 544.378 353.984 545.103 353.216C545.829 352.448 546.693 352.064 547.695 352.064C548.858 352.064 549.765 352.432 550.415 353.168C551.066 353.893 551.391 354.869 551.391 356.096C551.391 356.288 551.381 356.448 551.359 356.576H545.567C545.578 357.259 545.802 357.819 546.239 358.256C546.687 358.693 547.237 358.912 547.887 358.912C548.986 358.912 549.706 358.395 550.047 357.36ZM561.583 352.224V353.824C561.359 353.792 561.141 353.776 560.927 353.776C559.519 353.776 558.815 354.565 558.815 356.144V360H557.311V352.304H558.783V353.648C559.253 352.667 560.021 352.176 561.087 352.176C561.258 352.176 561.423 352.192 561.583 352.224ZM564.084 355.36H568.292C568.271 354.784 568.079 354.315 567.716 353.952C567.353 353.579 566.841 353.392 566.18 353.392C565.583 353.392 565.092 353.589 564.708 353.984C564.324 354.368 564.116 354.827 564.084 355.36ZM568.516 357.36L569.812 357.808C569.588 358.523 569.172 359.109 568.564 359.568C567.956 360.016 567.22 360.24 566.356 360.24C565.279 360.24 564.361 359.872 563.604 359.136C562.857 358.389 562.484 357.387 562.484 356.128C562.484 354.955 562.847 353.984 563.572 353.216C564.297 352.448 565.161 352.064 566.164 352.064C567.327 352.064 568.233 352.432 568.884 353.168C569.535 353.893 569.86 354.869 569.86 356.096C569.86 356.288 569.849 356.448 569.828 356.576H564.036C564.047 357.259 564.271 357.819 564.708 358.256C565.156 358.693 565.705 358.912 566.356 358.912C567.455 358.912 568.175 358.395 568.516 357.36ZM575.012 353.456C574.361 353.456 573.807 353.691 573.348 354.16C572.9 354.629 572.676 355.291 572.676 356.144C572.676 356.987 572.9 357.648 573.348 358.128C573.807 358.608 574.367 358.848 575.028 358.848C575.668 358.848 576.153 358.688 576.484 358.368C576.825 358.048 577.055 357.68 577.172 357.264L578.5 357.84C578.287 358.48 577.881 359.04 577.284 359.52C576.697 360 575.945 360.24 575.028 360.24C573.908 360.24 572.98 359.851 572.244 359.072C571.508 358.293 571.14 357.317 571.14 356.144C571.14 354.949 571.508 353.973 572.244 353.216C572.98 352.448 573.903 352.064 575.012 352.064C575.951 352.064 576.708 352.304 577.284 352.784C577.871 353.264 578.255 353.84 578.436 354.512L577.076 355.088C576.959 354.64 576.735 354.256 576.404 353.936C576.073 353.616 575.609 353.456 575.012 353.456ZM581.77 358.176C582.24 358.656 582.81 358.896 583.482 358.896C584.154 358.896 584.72 358.656 585.178 358.176C585.648 357.685 585.882 357.008 585.882 356.144C585.882 355.291 585.648 354.624 585.178 354.144C584.72 353.653 584.154 353.408 583.482 353.408C582.81 353.408 582.24 353.653 581.77 354.144C581.312 354.624 581.082 355.291 581.082 356.144C581.082 357.008 581.312 357.685 581.77 358.176ZM580.65 353.232C581.397 352.453 582.341 352.064 583.482 352.064C584.624 352.064 585.562 352.453 586.298 353.232C587.045 354 587.418 354.971 587.418 356.144C587.418 357.328 587.05 358.309 586.314 359.088C585.578 359.856 584.634 360.24 583.482 360.24C582.33 360.24 581.386 359.856 580.65 359.088C579.914 358.309 579.546 357.328 579.546 356.144C579.546 354.971 579.914 354 580.65 353.232ZM593.615 352.224V353.824C593.391 353.792 593.172 353.776 592.959 353.776C591.551 353.776 590.847 354.565 590.847 356.144V360H589.343V352.304H590.815V353.648C591.284 352.667 592.052 352.176 593.119 352.176C593.289 352.176 593.455 352.192 593.615 352.224ZM596.035 356.128C596.035 356.939 596.233 357.6 596.627 358.112C597.033 358.624 597.587 358.88 598.291 358.88C598.963 358.88 599.502 358.619 599.907 358.096C600.313 357.573 600.515 356.907 600.515 356.096C600.515 355.296 600.318 354.651 599.923 354.16C599.529 353.669 598.99 353.424 598.307 353.424C597.625 353.424 597.075 353.675 596.659 354.176C596.243 354.677 596.035 355.328 596.035 356.128ZM600.531 358.96V358.832C600.329 359.227 600.019 359.557 599.603 359.824C599.198 360.08 598.713 360.208 598.147 360.208C597.049 360.208 596.163 359.824 595.491 359.056C594.83 358.277 594.499 357.301 594.499 356.128C594.499 355.008 594.841 354.059 595.523 353.28C596.206 352.491 597.081 352.096 598.147 352.096C598.777 352.096 599.289 352.224 599.683 352.48C600.078 352.725 600.35 353.029 600.499 353.392V348.416H601.987V358.576C601.987 359.099 602.014 359.573 602.067 360H600.611C600.558 359.701 600.531 359.355 600.531 358.96ZM603.826 358L605.186 357.52C605.239 357.936 605.42 358.283 605.73 358.56C606.039 358.827 606.455 358.96 606.978 358.96C607.383 358.96 607.703 358.864 607.938 358.672C608.172 358.469 608.29 358.224 608.29 357.936C608.29 357.424 607.959 357.093 607.298 356.944L605.986 356.656C605.388 356.528 604.919 356.272 604.578 355.888C604.236 355.504 604.066 355.04 604.066 354.496C604.066 353.835 604.332 353.264 604.866 352.784C605.41 352.304 606.055 352.064 606.802 352.064C607.292 352.064 607.73 352.139 608.114 352.288C608.498 352.427 608.796 352.613 609.01 352.848C609.223 353.083 609.383 353.301 609.49 353.504C609.596 353.707 609.676 353.915 609.73 354.128L608.402 354.624C608.38 354.496 608.343 354.373 608.29 354.256C608.236 354.128 608.151 353.989 608.034 353.84C607.927 353.691 607.767 353.573 607.554 353.488C607.34 353.392 607.09 353.344 606.802 353.344C606.428 353.344 606.119 353.445 605.874 353.648C605.639 353.851 605.522 354.091 605.522 354.368C605.522 354.859 605.815 355.168 606.402 355.296L607.65 355.568C608.332 355.717 608.855 355.995 609.218 356.4C609.591 356.795 609.778 357.28 609.778 357.856C609.778 358.464 609.527 359.013 609.026 359.504C608.535 359.995 607.847 360.24 606.962 360.24C606.012 360.24 605.271 360.005 604.738 359.536C604.204 359.056 603.9 358.544 603.826 358ZM616.756 355.36H620.964C620.943 354.784 620.751 354.315 620.388 353.952C620.025 353.579 619.513 353.392 618.852 353.392C618.255 353.392 617.764 353.589 617.38 353.984C616.996 354.368 616.788 354.827 616.756 355.36ZM621.188 357.36L622.484 357.808C622.26 358.523 621.844 359.109 621.236 359.568C620.628 360.016 619.892 360.24 619.028 360.24C617.951 360.24 617.033 359.872 616.276 359.136C615.529 358.389 615.156 357.387 615.156 356.128C615.156 354.955 615.519 353.984 616.244 353.216C616.969 352.448 617.833 352.064 618.836 352.064C619.999 352.064 620.905 352.432 621.556 353.168C622.207 353.893 622.532 354.869 622.532 356.096C622.532 356.288 622.521 356.448 622.5 356.576H616.708C616.719 357.259 616.943 357.819 617.38 358.256C617.828 358.693 618.377 358.912 619.028 358.912C620.127 358.912 620.847 358.395 621.188 357.36ZM623.254 360L626.118 356.08L623.35 352.304H625.174L627.062 355.008L628.918 352.304H630.694L627.958 356.08C628.107 356.283 628.576 356.933 629.366 358.032C630.155 359.131 630.63 359.787 630.79 360H628.982L626.998 357.168L625.046 360H623.254ZM633.721 360H632.233V352.304H633.721V360ZM632.201 350.16C631.998 349.947 631.897 349.691 631.897 349.392C631.897 349.093 631.998 348.837 632.201 348.624C632.414 348.411 632.67 348.304 632.969 348.304C633.268 348.304 633.524 348.411 633.737 348.624C633.95 348.827 634.057 349.083 634.057 349.392C634.057 349.691 633.95 349.947 633.737 350.16C633.524 350.363 633.268 350.464 632.969 350.464C632.67 350.464 632.414 350.363 632.201 350.16ZM635.56 358L636.92 357.52C636.973 357.936 637.155 358.283 637.464 358.56C637.773 358.827 638.189 358.96 638.712 358.96C639.117 358.96 639.437 358.864 639.672 358.672C639.907 358.469 640.024 358.224 640.024 357.936C640.024 357.424 639.693 357.093 639.032 356.944L637.72 356.656C637.123 356.528 636.653 356.272 636.312 355.888C635.971 355.504 635.8 355.04 635.8 354.496C635.8 353.835 636.067 353.264 636.6 352.784C637.144 352.304 637.789 352.064 638.536 352.064C639.027 352.064 639.464 352.139 639.848 352.288C640.232 352.427 640.531 352.613 640.744 352.848C640.957 353.083 641.117 353.301 641.224 353.504C641.331 353.707 641.411 353.915 641.464 354.128L640.136 354.624C640.115 354.496 640.077 354.373 640.024 354.256C639.971 354.128 639.885 353.989 639.768 353.84C639.661 353.691 639.501 353.573 639.288 353.488C639.075 353.392 638.824 353.344 638.536 353.344C638.163 353.344 637.853 353.445 637.608 353.648C637.373 353.851 637.256 354.091 637.256 354.368C637.256 354.859 637.549 355.168 638.136 355.296L639.384 355.568C640.067 355.717 640.589 355.995 640.952 356.4C641.325 356.795 641.512 357.28 641.512 357.856C641.512 358.464 641.261 359.013 640.76 359.504C640.269 359.995 639.581 360.24 638.696 360.24C637.747 360.24 637.005 360.005 636.472 359.536C635.939 359.056 635.635 358.544 635.56 358ZM645.53 349.872V352.304H647.194V353.664H645.53V357.664C645.53 358.027 645.61 358.293 645.77 358.464C645.941 358.635 646.218 358.72 646.602 358.72C646.826 358.72 647.024 358.699 647.194 358.656V359.936C646.938 360.032 646.597 360.08 646.17 360.08C645.509 360.08 644.986 359.888 644.602 359.504C644.218 359.12 644.026 358.581 644.026 357.888V353.664H642.554V352.304H642.97C643.365 352.304 643.658 352.197 643.85 351.984C644.053 351.76 644.154 351.472 644.154 351.12V349.872H645.53ZM655.122 363.216H653.474L655.394 359.152L652.082 352.304H653.81L656.21 357.616L658.514 352.304H660.13L655.122 363.216ZM662.24 355.36H666.448C666.427 354.784 666.235 354.315 665.872 353.952C665.51 353.579 664.998 353.392 664.336 353.392C663.739 353.392 663.248 353.589 662.864 353.984C662.48 354.368 662.272 354.827 662.24 355.36ZM666.672 357.36L667.968 357.808C667.744 358.523 667.328 359.109 666.72 359.568C666.112 360.016 665.376 360.24 664.512 360.24C663.435 360.24 662.518 359.872 661.76 359.136C661.014 358.389 660.64 357.387 660.64 356.128C660.64 354.955 661.003 353.984 661.728 353.216C662.454 352.448 663.318 352.064 664.32 352.064C665.483 352.064 666.39 352.432 667.04 353.168C667.691 353.893 668.016 354.869 668.016 356.096C668.016 356.288 668.006 356.448 667.984 356.576H662.192C662.203 357.259 662.427 357.819 662.864 358.256C663.312 358.693 663.862 358.912 664.512 358.912C665.611 358.912 666.331 358.395 666.672 357.36ZM671.952 349.872V352.304H673.616V353.664H671.952V357.664C671.952 358.027 672.032 358.293 672.192 358.464C672.363 358.635 672.64 358.72 673.024 358.72C673.248 358.72 673.446 358.699 673.616 358.656V359.936C673.36 360.032 673.019 360.08 672.592 360.08C671.931 360.08 671.408 359.888 671.024 359.504C670.64 359.12 670.448 358.581 670.448 357.888V353.664H668.976V352.304H669.392C669.787 352.304 670.08 352.197 670.272 351.984C670.475 351.76 670.576 351.472 670.576 351.12V349.872H671.952Z",
    fill: "#0F172B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4608_134371",
    x: 460,
    y: 201,
    width: 157,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4608_134371"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4608_134371",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4608_134371",
    x: 503,
    y: 244,
    width: 157,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4608_134371"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4608_134371",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4608_134371",
    x: 460,
    y: 287,
    width: 157,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4608_134371"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4608_134371",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4608_134371",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(560 280) rotate(90) scale(280 560)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4608_134371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1120,
    height: 560,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4608_134371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(475.5 213.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4608_134371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(518.5 256.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_4608_134371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(475.5 299.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesheetEmptyImg);
export default __webpack_public_path__ + "static/media/timesheet-empty-img.479aa0507b59051ac9a0819bd910ec0c.svg";
export { ForwardRef as ReactComponent };